"use strict";
/// <reference path="lodash-fp.d.ts" />

var _set = require("babel-runtime/core-js/set");

var _set2 = _interopRequireDefault(_set);

var _typeof2 = require("babel-runtime/helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

var _iterator = require("babel-runtime/core-js/symbol/iterator");

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = require("babel-runtime/core-js/symbol");

var _symbol2 = _interopRequireDefault(_symbol);

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = _promise2.default))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function (thisArg, body) {
    var _ = { label: 0, sent: function sent() {
            if (t[0] & 1) throw t[1];return t[1];
        }, trys: [], ops: [] },
        f,
        y,
        t,
        g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof _symbol2.default === "function" && (g[_iterator2.default] = function () {
        return this;
    }), g;
    function verb(n) {
        return function (v) {
            return step([n, v]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) {
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:case 1:
                        t = op;break;
                    case 4:
                        _.label++;return { value: op[1], done: false };
                    case 5:
                        _.label++;y = op[1];op = [0];continue;
                    case 7:
                        op = _.ops.pop();_.trys.pop();continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];t = op;break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];_.ops.push(op);break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [6, e];y = 0;
            } finally {
                f = t = 0;
            }
        }if (op[0] & 5) throw op[1];return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = require("./util");
var lodash_alt_1 = require("./lodash-alt");
// import last = require("lodash/fp/last")
// import * as last from "lodash/fp/last"
// import { Dictionary } from "lodash/fp";
var LocaleProvider = require("@alicd/next-locale-provider");
// import LocaleProvider from "@alicd/next/lib/locale-provider";
var Constant_1 = require("./Constant");
function getRequestParams(props) {
    return {
        addressURL: props.requestAddressUrl,
        townURL: props.requestTownUrl,
        parentURL: props.requestAddressLevelUrl,
        ignored: props.ignored,
        dataOverride: props.dataOverride,
        preprocessor: props.preprocessor
    };
}
exports.getRequestParams = getRequestParams;
function setStateAsync(self, updater) {
    return new _promise2.default(function (resolve, reject) {
        self.setState(updater, function () {
            return resolve();
        });
    });
}
exports.setStateAsync = setStateAsync;
function loadAndStoreDataset(self, params) {
    if (params === void 0) {
        params = getRequestParams(self.props);
    }
    return __awaiter(this, void 0, void 0, function () {
        var _a, countryList, allNodesSet, addressTree, selfE;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    return [4 /*yield*/, util_1.loadAddressData(params)];
                case 1:
                    _a = _b.sent(), countryList = _a.countryList, allNodesSet = _a.allNodesSet, addressTree = _a.addressTree;
                    selfE = self;
                    selfE.allNodesSet = allNodesSet;
                    return [4 /*yield*/, setStateAsync(self, {
                        countryList: countryList,
                        addressTree: addressTree,
                        paneRoot: allNodesSet["1"]
                    })];
                case 2:
                    _b.sent();
                    return [2 /*return*/, {
                        addressTree: addressTree,
                        allNodesSet: allNodesSet
                    }];
            }
        });
    });
}
exports.loadAndStoreDataset = loadAndStoreDataset;
function dataset(self, params) {
    if (params === void 0) {
        params = getRequestParams(self.props);
    }
    return __awaiter(this, void 0, void 0, function () {
        var selfE;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    selfE = self;
                    if (!self.state.paneRoot) return [3 /*break*/, 1];
                    return [2 /*return*/, {
                        addressTree: self.state.addressTree,
                        allNodesSet: self.allNodesSet
                    }];
                case 1:
                    if (!selfE._futureDataset) {
                        selfE._futureDataset = loadAndStoreDataset(self, params);
                    }
                    return [4 /*yield*/, selfE._futureDataset];
                case 2:
                    return [2 /*return*/, _a.sent()];
            }
        });
    });
}
exports.dataset = dataset;
function selectNodeFromChain(node, chain) {
    var ret = [node];
    if (!chain.length) {
        return ret;
    }
    if (!node.children || node.isLeaf) {
        throw new Error("children expected for node " + node.id + ", chain " + chain);
    }
    var nextRoot = node.children.find(function (node) {
        return node.id == chain[0];
    });
    if (!nextRoot) {
        throw new Error("children " + chain[0] + " expected for node " + node.id + ", chain " + chain);
    }
    return ret.concat(selectNodeFromChain(nextRoot, chain.slice(1, chain.length)));
}
exports.selectNodeFromChain = selectNodeFromChain;
function nodeChainFromNode(node) {
    if (!node) return [];
    return (!node.parentNode ? [] : nodeChainFromNode(node.parentNode)).concat(node);
}
exports.nodeChainFromNode = nodeChainFromNode;
function foldNodeChainToSelection(nodeChain) {
    var ret = {};
    nodeChain.forEach(function (node) {
        return ret[node.levelKey] = node.id;
    });
    return ret;
}
exports.foldNodeChainToSelection = foldNodeChainToSelection;
function selectionToChain(value) {
    // TODO: fix the dictionary type
    return util_1.PANE_LEVEL_KEYS // keys array, must be in order
    .map(function (key) {
        return value[key];
    })
    // necessary because there is cases that one or more
    //  intermediate levels with no value
    .filter(function (v) {
        return !!v;
    });
}
exports.selectionToChain = selectionToChain;
function anyValueToSelectionId(val) {
    switch (typeof val === "undefined" ? "undefined" : (0, _typeof3.default)(val)) {
        case "string":
        case "number":
            return val.toString();
        default:
            // didn't used switch case
            //  because TS's inference is kind of dumb ...
            if ((typeof val === "undefined" ? "undefined" : (0, _typeof3.default)(val)) == "object") {
                var ret = lodash_alt_1.last(selectionToChain(val));
                if (ret) {
                    return ret;
                }
            }
            throw "invalid address anyValue " + val;
    }
}
exports.anyValueToSelectionId = anyValueToSelectionId;
exports.addressEqual = function (lhs, rhs) {
    return anyValueToSelectionId(lhs) == anyValueToSelectionId(rhs);
};
exports.CANNOT_REACH = "CANNOT_REACH";
function maybeGet(src) {
    return src;
}
exports.maybeGet = maybeGet;
function selectionChainLastNonstrict(chain) {
    if (chain.length) {
        return lodash_alt_1.last(chain);
    } else {
        return "";
    }
}
exports.selectionChainLastNonstrict = selectionChainLastNonstrict;
function nodeChainLastIDNonstrict(chain) {
    if (chain.length) {
        return lodash_alt_1.last(chain).id;
    } else {
        return "";
    }
}
exports.nodeChainLastIDNonstrict = nodeChainLastIDNonstrict;
// export function decorateValueInternal(
//         value: NodeSelection, nodeChain: NodeChain): NodeSelection {
//     let lastName = "";
//     let id = "";
//     if (nodeChain.length) {
//         const l = last(nodeChain);
//         id = l.id;
//         lastName = l.nameZh;
//     }
//     Object.defineProperty(value, "__addressValueInternalData", {
//         get () {
//             return { nodeChain, lastName, id };
//         }
//     });
//     return value;
// }
// export function valueInternalDecorated(value: NodeSelection, id: string): boolean {
//     if (!value || typeof value != "object") { return false; }
//     const v = ((value as any)["__addressValueInternalData"]) as
//         NodeSelectionInternalData;
//     return (!!v) && (v.id == id);
// }
// export function valueInternalDecorated2(value: number | string | NodeSelection): boolean {
//     if (typeof value == "number" || typeof value == "string") { return false; }
//     const v = ((value as any)["__addressValueInternalData"]) as
//         NodeSelectionInternalData;
//     if (!v) { return false; }
//     const id = selectionToChain(value);
//     if (id.toString() != v.id) { return false; }
//     return true;
// }
exports.id = function (v) {
    return v;
};
function getParentSetOf(node) {
    var nodeChain = nodeChainFromNode(node);
    var ret = new _set2.default();
    nodeChain.forEach(function (v) {
        return ret.add(v.id);
    });
    return ret;
}
exports.getParentSetOf = getParentSetOf;
function isDescendantOfOne(allNodesSet, childId, parentIds) {
    // TODO: use LCA-like alg. to opt.
    var childNode = allNodesSet[childId.toString()];
    var parents = getParentSetOf(childNode);
    for (var _i = 0, parentIds_1 = parentIds; _i < parentIds_1.length; _i++) {
        var parentId = parentIds_1[_i];
        if (parentId != childId && parents.has(parentId)) {
            return true;
        }
    }
    return false;
}
exports.isDescendantOfOne = isDescendantOfOne;
exports.PROVINCE_LETTERS = ["A–G", "H–K", "L–S", "T–Z"];
function provinceLetterParititon(namePy) {
    var c = namePy[0];
    if (c <= 'g') {
        return 0;
    } else if (c <= 'k') {
        return 1;
    } else if (c <= 's') {
        return 2;
    } else {
        return 3;
    }
}
exports.provinceLetterParititon = provinceLetterParititon;
function lastOr(src, def) {
    if (src.length) {
        return src[src.length - 1];
    } else {
        return def;
    }
}
exports.lastOr = lastOr;
function selectionToId(src) {
    return lastOr(src, Constant_1.ADDRTREE_ROOT_KEY);
}
exports.selectionToId = selectionToId;
function getLabelIntl(node) {
    if (node.parent == "0") {
        // return node.label;
        return LocaleProvider.get() == "zh-cn" ? node.nameZh : node.label;
    } else {
        return node.label;
    }
}
exports.getLabelIntl = getLabelIntl;
function getNodeLevelInTree(node) {
    if ("_cachedLevelInTree" in node) {
        return node._cachedLevelInTree;
    }
    function f(node, i) {
        return node.parentNode ? f(node.parentNode, i + 1) : i;
    }
    var ret = f(node, 0);
    node._cachedLevelInTree = ret;
    return ret;
}
exports.getNodeLevelInTree = getNodeLevelInTree;
//# sourceMappingURL=Common.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-address@0.0.80@@alicd/crui-address/lib/Common.js
// module id = 61
// module chunks = 0